<template>
  <svg
    width="22"
    height="22"
    fill="#000000"
    viewBox="0 0 141.76195 142.66132"
    version="1.1"
    id="svg-facebook"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg">
    <!-- Facebook background -->
    <path
      d="M 0,10.21937 C 0,4.5768893 4.6901226,0 10.475944,0 H 131.28602 c 5.78562,0 10.47593,4.5768893 10.47593,10.21937 v 122.22258 c 0,5.64438 -4.69031,10.21936 -10.47593,10.21936 H 10.475944 C 4.6901226,142.66131 0,138.08633 0,132.44195 Z"
      style="
        fill: #009eda;
        fill-opacity: 1;
        fill-rule: nonzero;
        stroke: none;
        stroke-width: 8.15063;
      "
      id="fb-background" />
    <!-- Facebook "f" logo -->
    <path
      d="M 98.53,142.66 V 87.92 h 18.36 l 2.75,-21.32 h -21.11 v -13.6 c 0,-6.17 1.71,-10.38 10.55,-10.38 l 11.28,-0.01 v -19.07 c -1.95,-0.26 -8.65,-0.84 -16.44,-0.84 -16.26,0 -27.4,9.92 -27.4,28.13 v 15.7 H 57.15 v 21.32 h 19.37 v 54.81 z"
      style="fill: #ffffff; fill-opacity: 1; fill-rule: evenodd; stroke: none; stroke-width: 1"
      id="fb-f" />
  </svg>
</template>
